import {CommonActionTypes} from '@/store/actions/types';
import axios from 'axios';
import {BranchListMessages, StoreFacilitiesMessages} from '@/maps/common';
import {CommonApi} from '@/request/api/common';
import {CertificateCampData} from '@/views/media/certificate/components/certificate-camp';

const CommonActions = {
  async [CommonActionTypes.GET_BRANCH_LIST](context: any, params?: { lat: number; lot: number; }): Promise<Array<BranchListMessages>> {
    let data = await axios.get<Array<BranchListPretty>>(`api/BranchList`, {params: params});
    let list: Array<BranchListMessages | any> = data.data.map((va) => {
      return {
        equipment: [],
        key: va.id,
        shopName: va.name,
        address: va.address,
        map: {lat: va.latitude, lon: va.longitude},
        time: `周二至周日8:30 – 22:00`,
        path: va.region,
        phone: `400-175-9284`
      };
    });
    return Promise.resolve(list);
  },
  async [CommonActionTypes.GET_STORE_FACILITIES](context: any, params?: { store_id: number }) {
    let {data} = await axios.get<StoreFacilitiesPretty>(`api/StoreFacilities`, {params: params});
    let facilities: Array<StoreFacilitiesMessages> = [];
    for (let facName in data) {
      // @ts-ignore
      let list = data[facName].map(fac => {
        return {
          icon: fac.facilities.icon,
          name: fac.facilities.name
        };
      });
      facilities.push({
        title: facName,
        facList: list
      });
    }
    return Promise.resolve(facilities);
  },

  async [CommonActionTypes.GET_CERTIFICATE_LIST](context: any, payload: { params: { semester_id: number; start_date?: string } }) {
    let data: any = await CommonApi.getCertificateList(payload.params);
    if (data.total == 0) {
      return [];
    }
    let dataMap: Map<string, Array<CertificateCampData>> = new Map<string, Array<CertificateCampData>>();
    let COURSE_NAME_REGEXP = new RegExp(/[^\(]+/);
    for (let list of data.list) {
      let certificatel: CertificateCampData = list;
      let findName = '';
      let key = `${certificatel.course_name}--${certificatel.store_name}`;
      dataMap.forEach((data, key1) => {
        if (data.length > 0) {
          if (data[0].store_id == certificatel.store_id
            // && data[0].main_teacher != certificatel.main_teacher
            && data[0].begin_date == certificatel.begin_date
            && COURSE_NAME_REGEXP.exec(data[0].course_name)![0] == COURSE_NAME_REGEXP.exec(certificatel.course_name)![0]
            && data[0].end_date == certificatel.end_date) { //判断门店id,主客老师,用户名称,开始结束时间,课程名称
            data.forEach((find, index) => { //判断位置
              
              if (find.name == certificatel.name) {
                data.splice(index, 1);
                findName = certificatel.name;
                //指导老师 + 1
                find.substitutes_teacher = certificatel.main_teacher!;
                find.substitutes_teacher_png = certificatel.main_teacher_png!;
                find.cumulative_hour = find.cumulative_hour + certificatel.cumulative_hour;
                dataMap.set(key1, data);  //该学员移至全天证书map
                let allKey = `${COURSE_NAME_REGEXP.exec(certificatel.course_name)![0]}[全天]--${certificatel.store_name}`;
                if (dataMap.has(allKey)) {
                  let ary: Array<CertificateCampData> = dataMap.get(allKey)!;
                  ary.push(Object.assign(find, {level: {label: 'xxxx', text: '请选择等级'}}));
                  dataMap.set(allKey, ary);
                } else {
                  dataMap.set(allKey, [Object.assign(find, {level: {label: 'xxxx', text: '请选择等级'}})]);
                }
              }
            });
          }
        }
      });
      if (findName) {
        continue;
      }
      if (dataMap.has(key)) {
        let ary: Array<CertificateCampData> = dataMap.get(key)!;
        ary.push(Object.assign(certificatel, {level: {label: 'xxxx', text: '请选择等级'}}));
        dataMap.set(key, ary);
      } else {
        dataMap.set(key, [Object.assign(certificatel, {level: {label: 'xxxx', text: '请选择等级'}})]);
      }
    }


    return dataMap;
  }
};
export default CommonActions;
